export const GRAPH_URL = "https://graph.facebook.com/v16.0";
